import { UserApi } from 'api-typings/users/users';

declare module '../core/backend' {
  interface BackendApiFetchTypes {
    userBalances: UserApi;
  }
}

export const userBalancesBackend = {
  fetch: () => ({
    endpoint: `users/0.1/self`,
    params: { balance_details: 1 },
  }),
};



// WEBPACK FOOTER //
// ./src/app/@shared/datastore/user-balances/user-balances.backend.ts